import { Columns3, RotateCcw } from 'lucide-react';
import { Button } from './ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuCheckboxItem,
  DropdownMenuSeparator,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { COLUMNS, CLIENT_COLUMNS } from '../hooks/useColumnConfig';

const GROUP_LABELS = {
  identity: 'Identity',
  revenue: 'Revenue',
  cost: 'Cost',
  margin: 'Margin',
  client: 'Client View',
};

export function ColumnSettings({ hidden, onToggle, onReset, showClientView }) {
  const allCols = showClientView ? [...COLUMNS, ...CLIENT_COLUMNS] : COLUMNS;
  const hideableCols = allCols.filter(c => c.hideable);

  // Group them
  const groups = {};
  hideableCols.forEach(c => {
    const g = c.group;
    if (!groups[g]) groups[g] = [];
    groups[g].push(c);
  });

  const groupOrder = showClientView
    ? ['identity', 'client', 'revenue', 'cost', 'margin']
    : ['identity', 'revenue', 'cost', 'margin'];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          className="h-8 gap-1.5 px-2.5 text-xs sm:h-9"
          data-testid="column-settings-btn"
        >
          <Columns3 className="h-3.5 w-3.5" />
          Columns
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48" data-testid="column-settings-menu">
        {groupOrder.map((g, gi) => (
          <div key={g}>
            {gi > 0 && <DropdownMenuSeparator />}
            <DropdownMenuLabel className="text-[10px] uppercase tracking-wider text-gray-400">
              {GROUP_LABELS[g] || g}
            </DropdownMenuLabel>
            {(groups[g] || []).map(col => (
              <DropdownMenuCheckboxItem
                key={col.id}
                checked={!hidden.has(col.id)}
                onCheckedChange={() => onToggle(col.id)}
                data-testid={`col-toggle-${col.id}`}
              >
                {col.label}
              </DropdownMenuCheckboxItem>
            ))}
          </div>
        ))}
        <DropdownMenuSeparator />
        <div className="p-1">
          <Button
            variant="ghost"
            size="sm"
            onClick={onReset}
            className="w-full h-7 text-xs gap-1.5 justify-start text-gray-500 hover:text-gray-900"
            data-testid="reset-layout-btn"
          >
            <RotateCcw className="h-3 w-3" />
            Reset layout
          </Button>
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
